import SuperRepository from '../superRepository'

export default new class RelatedStatusOfferRepository extends SuperRepository {
    baseUri () {
        return 'related_status_offer'
    }
}